import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { allIcons, allImages } from "../../../assets";
import GlobalButton from "./../../../components/CustomButton/index";
import appcolors from "../../../constants/Colors";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing("15px 20px"),
  },
}));
let paramsData = {};

const ConfirmAppointmentDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setTimeout(() => {
      handleClose();
    }, 5000);
  }, [open]);

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogContent>
        <Typography
          variant={"h1"}
          fontSize={"1.5rem"}
          fontWeight={600}
          textAlign={"center"}
        >
          Congratulation !
        </Typography>
        <Box textAlign={"center"} my={4}>
          <img src={allIcons.conformIcon} alt={"confirm-icon"} width={40} />
        </Box>
        <Typography
          fontSize={"0.875rem"}
          maxWidth={300}
          margin={"auto"}
          textAlign={"center"}
        >
          You done another appointment so wait for client review you earn 20 SAR
        </Typography>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default ConfirmAppointmentDialog;
